Service = App.loadClass 'core::Angular/Service'

class exports.SeedCompaniesService extends Service

    constructor: (@http, @rootScope) ->
        undefined

    all: (query = {}) ->
        return @http.post 'backend/grower/layers/planting-rx/ng-seed-companies', query

    ###
     * Provides limited list of seed companies, only displaying 'blacklisted'
     * or companies owned by the specified parent company.
    ###
    byCompany: (company, crop) ->
        return @http.post 'backend/grower/layers/planting-rx/ng-seed-companies', {
            companies_id: company,
            crops_id: crop
        }
